(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/shared/campaign.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/shared/campaign.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let logger;
let productMapping;
let getRules;
if (typeof exports === 'object') {
  const trinidadCore = require('trinidad-core').core;
  logger = trinidadCore.logger('numbergames:campaign');
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
  getRules = trinidadCore.components.require('numbergames', 'rules').getRules;
} else {
  logger = svs.numbergames.campaign._internal.logger;
  productMapping = svs.numbergames.productMapping;
  getRules = svs.numbergames.rules.getRules;
}
const partTermsMap = {
  NONE: 0,
  HAS_JOKER: 1,
  HAS_KUNG_KENO: 2
};

const getCampaignHeaderImage = campaignData => {
  var _campaignData;
  campaignData = (_campaignData = campaignData) === null || _campaignData === void 0 ? void 0 : _campaignData[0];
  if (campaignData) {
    return {
      largeImageUrl: campaignData.largeImageUrl,
      smallImageUrl: campaignData.smallImageUrl
    };
  }
  return null;
};

const hasActiveCampaign = (campaignData, _ref) => {
  var _campaignData$product, _campaignData2, _campaignData4;
  let {
    product
  } = _ref;
  campaignData = (_campaignData$product = (_campaignData2 = campaignData) === null || _campaignData2 === void 0 ? void 0 : _campaignData2[productMapping.getProductId(product)]) !== null && _campaignData$product !== void 0 ? _campaignData$product : campaignData;
  if (Array.isArray(campaignData)) {
    var _campaignData3;
    return Boolean((_campaignData3 = campaignData) === null || _campaignData3 === void 0 ? void 0 : _campaignData3.find(c => c.drawStateId === 2));
  }
  return ((_campaignData4 = campaignData) === null || _campaignData4 === void 0 ? void 0 : _campaignData4.drawStateId) === 2;
};

const calculateChances = function () {
  let {
    campaign,
    campaigns = [],
    wager,
    wagers = [],
    productDraws,
    useTotalChances
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!wager && !wagers) {
    logger.warn('Missing wager(s)');
    return 0;
  }
  if (campaign) {
    campaigns.push(campaign);
  }
  let productId = productMapping.getProductId(wager === null || wager === void 0 ? void 0 : wager.productId);
  if (wagers.length) {
    productId = productMapping.getProductId(wagers[0].bets[0].productId);
  }

  if (productMapping.isKeno(productId)) {
    const productDraw = productDraws === null || productDraws === void 0 ? void 0 : productDraws.find(_ref2 => {
      let {
        productItsId
      } = _ref2;
      return productMapping.isSameProduct(productItsId, productId);
    });
    if ((productDraw === null || productDraw === void 0 ? void 0 : productDraw.drawNumber) === 1) {
      return deprecatedCalculateChances(campaigns, {
        wager,
        productDraws
      });
    }
  }
  if (!Array.isArray(campaigns)) {
    campaigns = [campaigns];
  }
  if (wager) {
    return calculateChancesByWager({
      campaigns,
      wager,
      productDraws,
      useTotalChances
    });
  }
  return wagers.reduce((acc, currentWager) => acc + calculateChancesByWager({
    campaigns,
    wager: currentWager,
    productDraws,
    useTotalChances
  }), 0);
};

const calculateChancesByWager = _ref3 => {
  let {
    wager,
    campaigns,
    productDraws,
    useTotalChances
  } = _ref3;
  logger.debug("Campaign IDs before filter: ".concat(campaigns.map(c => c.drawNumber).join(', ')));
  wager = parseAPIWager(wager);
  const productId = wager.productId;
  if (!productId) {
    logger.warn('productId missing in wager');
  }

  campaigns = campaigns.filter(_ref4 => {
    let {
      drawTypeId,
      drawStateId
    } = _ref4;
    return drawStateId > 1 || drawTypeId === 1;
  });
  if (productMapping.isLotto(productId)) {
    if (!wager.hasJoker) {
      return 0;
    }
    wager.betAmount -= wager.jokerPrice * wager.totalDrawCount;
    campaigns = campaigns.filter(_ref5 => {
      let {
        drawTypeId
      } = _ref5;
      return drawTypeId === 1;
    });
  }
  const drawNumbers = [];
  if (productDraws !== null && productDraws !== void 0 && productDraws.length) {
    drawNumbers.push(...productDraws.filter(_ref6 => {
      let {
        productItsId
      } = _ref6;
      return productMapping.isSameProduct(productItsId, productId);
    }).map(_ref7 => {
      let {
        drawNumber
      } = _ref7;
      return drawNumber;
    }));
  } else {
    if (!wager.drawNumber) {
      logger.warn('Unable to find any drawNumber! Cannot calculate chances.');
      return 0;
    }
    drawNumbers.push(wager.drawNumber);
  }
  if (useTotalChances && drawNumbers.length === 1) {
    for (let i = 1; i < wager.totalDrawCount; i++) {
      drawNumbers.push(drawNumbers[0] + i);
    }
  }
  let chances = 0;
  for (const campaign of campaigns) {
    const campaignPeriodList = campaign.products.filter(p => productMapping.isSameProduct(p.productId, productId));
    if (!campaignPeriodList.length) {
      continue;
    }
    for (const campaignPeriod of campaignPeriodList) {
      const {
        startDrawNumber,
        endDrawNumber
      } = campaignPeriod;
      const numberOfEligibleDraws = drawNumbers.reduce((acc, drawNumber) => {
        const isEligible = drawNumber >= startDrawNumber && drawNumber <= endDrawNumber;
        logger.debug("drawNumber: ".concat(drawNumber, ", startDrawNumber: ").concat(startDrawNumber, ", endDrawNumber: ").concat(endDrawNumber, ". isEligible: ").concat(isEligible));
        return isEligible ? acc + 1 : acc;
      }, 0);
      logger.debug('numberOfEligibleDraws', numberOfEligibleDraws);
      const {
        rowPrice
      } = getRules({
        productId: productMapping.getProductId(productId)
      });
      const {
        betAmount,
        totalDrawCount
      } = wager;
      let chancePerDaw;
      if (productMapping.isLotto(productId) && wager.rowCount) {
        chancePerDaw = wager.rowCount * (wager.hasLotto2 + 1);
      } else {
        chancePerDaw = betAmount / parseInt(totalDrawCount, 10) / rowPrice;
      }
      chances += chancePerDaw * numberOfEligibleDraws;
    }
  }
  logger.debug("Calculated ".concat(chances, " chances."));
  return chances;
};

const parseAPIWager = wager => {
  var _wager$totalDrawCount, _bet$lottoBoards;
  wager = _objectSpread({}, wager);
  wager.betAmount = parseInt(wager.betAmount, 10);

  wager.productId = wager.productName ? productMapping.getProductNumeric(wager.productName) : wager.productId;
  if (wager.drawCount) {
    wager.totalDrawCount = parseInt(wager.drawCount, 10);
  }
  if (!wager.bets) {
    return wager;
  }
  const [bet, joker] = wager.bets;
  const {
    numDraws,
    drawNum = 1
  } = bet;
  const betAmount = wager.bets.reduce((acc, bet) => acc + parseInt(bet.betAmountSalesGroup1, 10) + parseInt(bet.betAmountSalesGroup2, 10), 0);
  const parsedWager = _objectSpread(_objectSpread({}, wager), {}, {
    productId: productMapping.getProductNumeric(bet.productId),
    betAmount,
    totalDrawCount: (_wager$totalDrawCount = wager.totalDrawCount) !== null && _wager$totalDrawCount !== void 0 ? _wager$totalDrawCount : numDraws,
    hasLotto2: (_bet$lottoBoards = bet.lottoBoards) === null || _bet$lottoBoards === void 0 ? void 0 : _bet$lottoBoards[0].participation.includes('L2'),
    hasJoker: Boolean(joker),
    drawNumber: drawNum
  });
  if (parsedWager.hasJoker) {
    const {
      betAmountSalesGroup1: jokerBetAmount,
      numDraws: jokerDrawNums
    } = joker;
    parsedWager.jokerPrice = parseInt(jokerBetAmount, 10) / parseInt(jokerDrawNums, 10);
  }
  return parsedWager;
};

const deprecatedCalculateChances = (data, _ref8) => {
  let {
    wager,
    productDraws
  } = _ref8;
  wager = parseAPIWager(wager);
  let rowCount;
  let drawCount = 0;
  if (productDraws) {
    productDraws.forEach(_ref9 => {
      let {
        productItsId,
        drawNumber
      } = _ref9;
      if (Array.isArray(data)) {
        data = data.find(_ref10 => {
          let {
            products
          } = _ref10;
          return products.find(_ref11 => {
            let {
              productId
            } = _ref11;
            return productMapping.isSameProduct(productId, productItsId);
          });
        });
      }
      if (!data) {
        logger.warn('Missing data. Possible error in API');
        return null;
      }
      const products = data.products.find(_ref12 => {
        let {
          productId
        } = _ref12;
        return productMapping.isSameProduct(productId, productItsId);
      });
      if (!products) {
        logger.warn('Missing products. Possible error in API');
        return null;
      }
      const {
        startDrawNumber,
        endDrawNumber
      } = products;
      for (let i = 0; i < wager.totalDrawCount; i++) {
        if (drawNumber + i >= startDrawNumber && drawNumber + i <= endDrawNumber) {
          drawCount++;
        }
      }
    });
  }
  switch (data.participationTermsId) {
    case partTermsMap.HAS_JOKER:
      rowCount = wager.hasJoker ? wager.rowCount * (wager.hasLotto2 + 1) : 0;
      break;
    case partTermsMap.HAS_KUNG_KENO:
      {
        const boards = Array.isArray(wager.bets) ? wager.bets[0].boards : wager.boards;
        rowCount = boards.filter(_ref13 => {
          let {
            hasKungKeno
          } = _ref13;
          return hasKungKeno;
        }).reduce((curr, _ref14) => {
          let {
            rowCount
          } = _ref14;
          return curr + rowCount;
        }, 0);
        break;
      }
    default:
      rowCount = wager.rowCount;
  }
  return rowCount * drawCount;
};

const getCampaignPeriod = campaignData => {
  if (campaignData) {
    return {
      startDate: campaignData.startDate,
      endDate: campaignData.endDate,
      drawDate: campaignData.drawDate
    };
  }
  return null;
};

const getCampaignName = campaignData => campaignData === null || campaignData === void 0 ? void 0 : campaignData.name;

const getWinPlan = campaignData => {
  var _campaignData$;
  return campaignData === null || campaignData === void 0 || (_campaignData$ = campaignData[0]) === null || _campaignData$ === void 0 ? void 0 : _campaignData$.winDivs;
};

const filterCampaignListByDrawNumber = _ref15 => {
  let {
    drawNumber,
    productId,
    campaignList
  } = _ref15;
  return campaignList.find(campaign => {
    const product = campaign.products.find(p => productMapping.isSameProduct(p.productId, productId));
    if (product) {
      const {
        startDrawNumber,
        endDrawNumber
      } = product;
      return drawNumber >= startDrawNumber && drawNumber <= endDrawNumber;
    }
    return null;
  });
};

const filterCampaignsByDate = _ref16 => {
  let {
    date,
    campaigns
  } = _ref16;
  return campaigns.find(_ref17 => {
    let {
      startDate,
      endDate
    } = _ref17;
    return dateFns.isWithinInterval(new Date(date), {
      start: new Date(startDate),
      end: dateFns.addDays(new Date(endDate), 1)
    });
  });
};
const campaign = {
  calculateChances,
  hasActiveCampaign,
  getCampaignHeaderImage,
  getCampaignPeriod,
  getCampaignName,
  getWinPlan,
  filterCampaignListByDrawNumber,
  filterCampaignsByDate
};
if (typeof exports === 'object') {
  module.exports = campaign;
} else {
  svs.numbergames.campaign.shared.campaign = campaign;
}

 })(window);